export class FilterEntity {
  constructor(
    public column?: string,
    public columnType?: string,
    public internalOperator: string = 'AND',
    public operator: string = 'LIKE',
    public valueBegin?: string,
    public valueEnd?: string,
    public entity?: string,
  ) { }
}
